import Avatar from "components/base/Avatar";
import { Dropdown, Modal, Nav, Button } from "react-bootstrap";
import avatar57 from "assets/img/team/user.png";
import ProfileDropdownMenu from "./ProfileDropdownMenu";
import FeatherIcon from "feather-icons-react";
import { Link } from "react-router-dom";
import NotificationDropdownMenu from "./NotificationDropdownMenu";
import { useState } from "react";
import DropdownSearchBox from "components/common/DropdownSearchBox";
import SearchResult from "components/common/SearchResult";
import { useAtom } from "jotai";
import { user_info } from "jotai/UserJotaiInstance";
import { UserInfo } from "interfaces/user";
import { useBreakpoints } from "providers/BreakpointsProvider";
import GlobalLeadSearch from "components/common/GlobalLeadSearch";
import "../navbar-top/NavbarMobile.css";

const NavItems = () => {
  const [userInfo] = useAtom<UserInfo>(user_info);
  const [openSearchModal, setOpenSearchModal] = useState(false);
  const [showMobileSearch, setShowMobileSearch] = useState(false);
  const { breakpoints } = useBreakpoints();

  return (
    <div className="navbar-nav navbar-nav-icons flex-row">
      {/* <Nav.Item>
        <ThemeToggler className="px-2" />
      </Nav.Item> */}
      {/* Mobile Search Icon - Only visible on small screens */}
      {!breakpoints.up('lg') && (
        <Nav.Item className="search-icon-item">
          {showMobileSearch ? (
            <div className="d-flex flex-grow-1 mobile-search-container">
              <GlobalLeadSearch />
              <Button 
                variant="link" 
                className="mobile-search-close" 
                onClick={() => setShowMobileSearch(false)}
              >
                ×
              </Button>
            </div>
          ) : (
            <Button 
              variant="link" 
              className="mobile-search-button" 
              onClick={() => setShowMobileSearch(true)}
            >
              <FeatherIcon icon="search" size={18} />
            </Button>
          )}
        </Nav.Item>
      )}
      <Nav.Item className="notification-icon-item">
        <Dropdown autoClose="outside" className="h-100">
          <Dropdown.Toggle
            as={Link}
            to="#!"
            className="dropdown-caret-none nav-link h-100"
            variant=""
          >
            <FeatherIcon icon="bell" size={20} />
          </Dropdown.Toggle>
          <NotificationDropdownMenu />
        </Dropdown>
      </Nav.Item>
      {/* <Nav.Item>
        <Dropdown autoClose="outside" className="h-100">
          <Dropdown.Toggle
            as={Link}
            to="#!"
            className="dropdown-caret-none nav-link h-100"
            variant=""
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="2" cy="2" r="2" fill="currentColor"></circle>
              <circle cx="2" cy="8" r="2" fill="currentColor"></circle>
              <circle cx="2" cy="14" r="2" fill="currentColor"></circle>
              <circle cx="8" cy="8" r="2" fill="currentColor"></circle>
              <circle cx="8" cy="14" r="2" fill="currentColor"></circle>
              <circle cx="14" cy="8" r="2" fill="currentColor"></circle>
              <circle cx="14" cy="14" r="2" fill="currentColor"></circle>
              <circle cx="8" cy="2" r="2" fill="currentColor"></circle>
              <circle cx="14" cy="2" r="2" fill="currentColor"></circle>
            </svg>
          </Dropdown.Toggle>
          <NineDotMenu />
        </Dropdown>
      </Nav.Item> */}
      <Nav.Item>
        <Dropdown autoClose="outside" className="h-100">
          <Dropdown.Toggle
            as={Link}
            to="#!"
            className="dropdown-caret-none nav-link pe-0 py-0 lh-1 h-100 d-flex align-items-center"
            variant=""
          >
            <Avatar src={userInfo?.user_image || avatar57} size="m" />
          </Dropdown.Toggle>
          <ProfileDropdownMenu />
        </Dropdown>
      </Nav.Item>

      <Modal
        show={openSearchModal}
        onHide={() => setOpenSearchModal(false)}
        className="search-box-modal mt-15"
      >
        <Modal.Body className="p-0 bg-transparent">
          <DropdownSearchBox
            className="navbar-top-search-box"
            inputClassName="rounded-pill"
            size="lg"
            style={{ width: "auto" }}
          >
            <SearchResult />
          </DropdownSearchBox>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default NavItems;